import "../css/Whatsapp.css";
function Whatsapp()
{
    return(
        <>
         <a
        href="https://wa.me/+919788718180"
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fa fa-whatsapp whatsapp-icon"></i>
      </a>

</>
    )
}

export default Whatsapp;